/* 🤖 this file was generated by svg-to-ts */
export const kzIconsSocialLinkedin: {
  name: 'social_linkedin';
  data: string;
} = {
  name: 'social_linkedin',
  data: `<svg viewBox="0 0 448 448" fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2"><path d="M100.28 448H7.4V148.9h92.88V448ZM53.79 108.1C24.09 108.1 0 83.5 0 53.8 0 24.292 24.282.01 53.79.01s53.79 24.282 53.79 53.79c0 29.7-24.1 54.3-53.79 54.3ZM448 448h-92.78V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448Z" transform="translate(0 -.01)" fill-rule="currentColor"/></svg>`
};
